<div class="filter-container flex-row">
  <mat-checkbox (change)="showOnlyMineChanged($event)" [(ngModel)]="showOnlyMine">Show only mine</mat-checkbox>
  <mat-checkbox (change)="groupBySkuChanged($event)" [(ngModel)]="groupBySku">Group by SKU</mat-checkbox>

  <mat-form-field appearance="outline" class="no-bottom manufacturer dense-minimum">
    <mat-label>Manufacturer</mat-label>
    <input #manufacturer
           [formControl]="manufacturerField"
           [matAutocomplete]="manufacturerAuto" matInput placeholder="Ex. ETC" type="text">
    <button (click)="clearManufacturer()" aria-label="Clear" mat-icon-button matSuffix>
      @if (selectedManufacturer) {
        <mat-icon>close</mat-icon>
      }
    </button>

  </mat-form-field>
  <mat-autocomplete #manufacturerAuto="matAutocomplete" (optionSelected)="manufacturerAutocompleteSelect($event)"
                    class="manufacturer-autocomplete" panelWidth="240px" requireSelection>
    @for (mfr of filteredManufacturers; track mfr.name) {
      <mat-option [value]="mfr.name">
        <span [innerHtml]="highlight(mfr.name, manufacturer.value)" class="manufacturer"></span>
      </mat-option>
    }
  </mat-autocomplete>
</div>

<div class="helper">
  @if (loading) {
    <mat-progress-spinner class="spinner" color="accent" mode="indeterminate"></mat-progress-spinner>
  } @else {
    @if (purchaseOrders.length == 0) {
      <p>No purchase orders</p>
    }
  }
</div>

<mat-accordion [class.loading]="loading" class="purchase-order-list">
  @for (p of purchaseOrders; track p.id + p.status) {
    <mat-expansion-panel (opened)="setActiveFragment(p.name)" [expanded]="p.name == activeFragment" [id]="p.name"
                         class="single-purchase-order" togglePosition="before">
      <mat-expansion-panel-header>
        <mat-panel-title>
          @if (p.status == PurchaseOrderStatus.DRAFT || p.status == PurchaseOrderStatus.GENERATED) {
            <mat-icon class="blue">traffic</mat-icon>
          } @else if (p.status == PurchaseOrderStatus.PENDING_INFO || p.status == PurchaseOrderStatus.ORDERED) {
            <mat-icon class="yellow">traffic</mat-icon>
          } @else {
            <mat-icon class="green">traffic</mat-icon>
          }

          <span class="main-text">
            {{ p.manufacturerNames }}
          </span>
          <span class="hint po-name flex-row">
            <span class="label">{{ p.name }}</span>
            @if (p.status == PurchaseOrderStatus.DRAFT) {
              <button (click)="edit(p); $event.stopPropagation()"
                      class="small-icon-button"
                      mat-icon-button>
                <mat-icon>edit</mat-icon>
              </button>
            }
          </span>
          <span class="hint po-status">
            {{ p.status | readable }}
          </span>

          <span class="actions">
            @if (p.status == PurchaseOrderStatus.DRAFT) {
              <button (click)="sendOrder(p); $event.stopPropagation()" color="primary" mat-raised-button
                      matTooltip="Transitions Purchase Order to Need Info state - you should send the order to supplier at this stage.">
                <mat-icon>forward_to_inbox</mat-icon>
                Execute
              </button>
            }
            @if (p.status == PurchaseOrderStatus.PENDING_INFO) {
              <button (click)="confirmOrder(p); $event.stopPropagation()" color="primary" mat-raised-button
                      matTooltip="Prompts you to add Sales Order Confirmation number and transitions Purchase Order to Ordered state. This means equipment is on the way.">
                <mat-icon fontSet="material-icons-outlined">inventory</mat-icon>
                Add SoC
              </button>
            }
          </span>
        </mat-panel-title>
        <mat-panel-description>{{ p.notes }}</mat-panel-description>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <div class="button-row flex-row">
          @if (p.status == PurchaseOrderStatus.GENERATED) {
            <button (click)="toDraft(p)" [disabled]="isButtonDisabled(p)"
                    color="accent" mat-mini-fab
                    matTooltip="Creates a new Purchase Order Draft from selected equipment.">
              <mat-icon>insert_drive_file</mat-icon>
            </button>
          }
          @if (p.status == PurchaseOrderStatus.DRAFT || p.status == PurchaseOrderStatus.PENDING_INFO) {
            <button (click)="remove(p)" [disabled]="isButtonDisabled(p)"
                    color="accent"
                    mat-mini-fab matTooltip="Transitions equipment back to Pending Order status and moves it back to Generated Purchase Orders">
              <mat-icon>delete</mat-icon>
            </button>
          }
          @if (p.status == PurchaseOrderStatus.DRAFT || p.status == PurchaseOrderStatus.GENERATED) {
            <button (click)="move(p)" [disabled]="isButtonDisabled(p)"
                    color="accent"
                    mat-mini-fab matTooltip="Move equipment to an existing draft Purchase Order.">
              <mat-icon>move_to_inbox</mat-icon>
            </button>
          }

          <!--@if (p.status == PurchaseOrderStatus.DRAFT || p.status == PurchaseOrderStatus.GENERATED || p.status == PurchaseOrderStatus.PENDING_INFO) {
            <button mat-raised-button (click)="exportXlsx(p)" [disabled]="isButtonDisabled(p)">Export .xlsx
            </button>
          }-->

        </div>

        @if (p.equipment.length == 0) {
          <p>No equipment left in this Purchase Order. Either move items here or delete this Purchase Order.</p>
          <button (click)="delete(p)" color="primary" mat-button>Delete</button>
        }
        <app-equipment-list (changed)="equipmentChanged(p, $event)" (checked)="selectionUpdated(p, $event)"
                            [equipment]="p.equipment"></app-equipment-list>
      </ng-template>

    </mat-expansion-panel>
  }
</mat-accordion>
